import React, { useState } from 'react';
import { Row, Col, Card, Form, Button, Spinner, Badge } from 'react-bootstrap';
import API from '../../api';

function UserManagement({ users, fetchUsers, setMessage }) {
    const [newUser, setNewUser] = useState({ username: '', password: '', email: '', rank: 'guest' });
    const [deleteUsername, setDeleteUsername] = useState('');
    const [loading, setLoading] = useState(false);

    const handleCreateUser = () => {
        setLoading(true);
        fetch(API.USERS_CREATE, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(newUser),
        })
        .then(response => response.json())
        .then(data => {
            setMessage(data.message);
            setLoading(false);
            if (data.status === 'success') {
                setNewUser({ username: '', password: '', email: '', rank: 'guest' });
                fetchUsers();
            }
        })
        .catch(error => { console.error('Error creating user:', error); setLoading(false); });
    };

    const handleDeleteUser = () => {
        setLoading(true);
        fetch(API.USERS_DELETE, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ username: deleteUsername }),
        })
        .then(response => response.json())
        .then(data => {
            setMessage(data.message);
            setLoading(false);
            if (data.status === 'success') { setDeleteUsername(''); fetchUsers(); }
        })
        .catch(error => { console.error('Error deleting user:', error); setLoading(false); });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewUser(prev => ({ ...prev, [name]: value }));
    };

    return (
        <Row>
            <Col md={6}>
                <Card className="admin-panel-card">
                    <Card.Header className="admin-panel-card-header">Create User</Card.Header>
                    <Card.Body>
                        <Form>
                            <Form.Group controlId="formUsername">
                                <Form.Label className="admin-panel-form-label">Username</Form.Label>
                                <Form.Control type="text" name="username" value={newUser.username} onChange={handleInputChange} placeholder="Enter username" className="admin-panel-input" />
                            </Form.Group>
                            <Form.Group controlId="formPassword" className="mt-3">
                                <Form.Label className="admin-panel-form-label">Password</Form.Label>
                                <Form.Control type="password" name="password" value={newUser.password} onChange={handleInputChange} placeholder="Enter password" className="admin-panel-input" />
                            </Form.Group>
                            <Form.Group controlId="formEmail" className="mt-3">
                                <Form.Label className="admin-panel-form-label">Email</Form.Label>
                                <Form.Control type="email" name="email" value={newUser.email} onChange={handleInputChange} placeholder="Enter email" className="admin-panel-input" />
                            </Form.Group>
                            <Form.Group controlId="formRank" className="mt-3">
                                <Form.Label className="admin-panel-form-label">Rank</Form.Label>
                                <Form.Control as="select" name="rank" value={newUser.rank} onChange={handleInputChange} className="admin-panel-select">
                                    <option value="guest">Guest</option>
                                    <option value="member">Member</option>
                                    <option value="root">Root</option>
                                </Form.Control>
                            </Form.Group>
                            <Button variant="primary" onClick={handleCreateUser} className="mt-4 admin-panel-button">
                                {loading ? <Spinner animation="border" size="sm" /> : 'Create User'}
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={6}>
                <Card className="admin-panel-card">
                    <Card.Header className="admin-panel-card-header">Delete User</Card.Header>
                    <Card.Body>
                        <Form>
                            <Form.Group controlId="formDeleteUsername">
                                <Form.Label className="admin-panel-form-label">Select User to Delete</Form.Label>
                                <Form.Control as="select" value={deleteUsername} onChange={(e) => setDeleteUsername(e.target.value)} className="admin-panel-select">
                                    <option value="">Select a user</option>
                                    {users.map((user) => (
                                        <option key={user.username} value={user.username}>{user.username} ({user.rank})</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Button variant="danger" onClick={handleDeleteUser} className="mt-4 admin-panel-button-danger">
                                {loading ? <Spinner animation="border" size="sm" /> : 'Delete User'}
                            </Button>
                        </Form>
                        <div className="mt-4">
                            <h5 className="admin-panel-subtitle">Current Users</h5>
                            <div className="admin-panel-users-list">
                                {users.map((user) => (
                                    <div key={user.username} className="admin-panel-user-item">
                                        <span className="admin-panel-user-name">{user.username}</span>
                                        <Badge bg={user.rank === 'root' ? 'danger' : (user.rank === 'member' ? 'primary' : 'secondary')} className="admin-panel-user-badge">{user.rank}</Badge>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}

export default UserManagement;
